import React from 'react';

import {
  Anchor,
  Button,
  Container,
  // Flex,
  Group,
  Paper,
  PasswordInput,
  TextInput,
  Title,
  // useMantineTheme,
} from '@mantine/core';
import { useForm } from '@mantine/form';
// import { useMediaQuery } from '@mantine/hooks';
import { ReactComponent as KiloLogo } from 'assets/svg/long_kilo_blue_white.svg';
// import config from 'config';
import { useAuth } from 'context/auth-context';
import { Link, Navigate } from 'react-router-dom';
import { emailValidator } from 'utils/form-validators';
// import { authenticateApple, authenticateFacebook, authenticateGoogle } from 'utils/social-auth';

interface FormValues {
  email: string;
  password: string;
}

const Login = (): JSX.Element => {
  const { login, session, isLoading } = useAuth();
  // const theme = useMantineTheme();
  // const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.md}`, false);

  const form = useForm<FormValues>({
    initialValues: {
      email: '',
      password: '',
    },

    validate: {
      email: value => emailValidator(value),
      password: value => (value ? null : 'Required'),
    },
  });

  const handleSubmit = (formValues: FormValues): void => {
    login(formValues);
  };

  if (session?.profile) {
    return <Navigate to='/' />;
  }

  return (
    <Container size='xs' py='xl'>
      <KiloLogo width='100%' height={60} />
      <Title align='center' mt='xl' sx={{ fontWeight: 900 }}>
        Welcome back!
      </Title>
      <Paper withBorder shadow='md' p={30} mt={30} radius='md'>
        <form onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput
            label='Email'
            placeholder='jane@mygym.com'
            data-testid='userInput'
            name='userInput'
            type='email'
            required
            {...form.getInputProps('email')}
          />
          <PasswordInput
            label='Password'
            placeholder='•••••••'
            data-testid='passInput'
            name='passInput'
            required
            mt='md'
            {...form.getInputProps('password')}
          />
          <Group position='center' mt='md' px='xs' noWrap spacing='xs'>
            <Anchor component={Link} to='/reset-password' size='sm'>
              Forgot password?
            </Anchor>
          </Group>
          <Button
            fullWidth
            mt='xl'
            type='submit'
            data-testid='loginSubmit'
            name='loginSubmit'
            loading={isLoading}
          >
            Sign in
          </Button>
          {/* {isDesktop && config.SSO_LOGIN_ENABLED === 'true' && (
            <Flex gap='xs' justify='center' align='center'>
              <Button
                fullWidth
                variant='outline'
                color='gray'
                mt='md'
                onClick={() => authenticateGoogle(false)}
              >
                Google Login
              </Button>
              <Button
                fullWidth
                variant='outline'
                color='gray'
                mt='md'
                onClick={() => authenticateFacebook(false)}
              >
                Facebook Login
              </Button>
              <Button
                fullWidth
                variant='outline'
                color='gray'
                mt='md'
                onClick={() => authenticateApple(false)}
              >
                Apple Login
              </Button>
            </Flex>
          )} */}
        </form>
      </Paper>
    </Container>
  );
};

export default Login;
